import { Token } from "inversify-token";
import { SvelteComponent } from "svelte";

export type CardsLibraryRecord = { "default": typeof SvelteComponent, [ key: string ]: any };

export const CardsLibraryToken = new Token<CardsLibraryRecord>(Symbol.for("CardsLibraryRecord"));
